import { useCallback, useEffect, useState } from 'react'

import { ITabItem, TabItem } from '@/src/components/pip/components/Tabs/TabItem/TabItem'

import Main from '@/src/assets/icons/MainPip'
import Participants from '@/src/assets/icons/UsersIcon'
import Chat from '@/src/assets/icons/ChatIcon'

import { useLayoutContext } from '@/src/context'

import { useParticipantsList } from '@/src/hooks/participant/useParticipantsList'

import { useAppDispatch, useAppSelector } from '@/src/store/hooks'
import { selectPiPCurrentTab, setCurrentTab, TPiPTab } from '@/src/store/slices/pip'
import { selectUnreadMessages, setIsOpenChat } from '@/src/store/slices/chat'
import { selectIsAdmin } from '@/src/store/slices/meetData'

const tabs: ITabItem[] = [
  {
    value: 'home',
    icon: <Main />,
  },
  {
    value: 'participants',
    icon: <Participants />,
  },
  {
    value: 'chat',
    icon: <Chat />,
  },
]

export const TabsPanel = () => {
  const [displayedTabs, setDisplayedTabs] = useState<ITabItem[]>(tabs)

  const { dispatch: changeLayoutContext } = useLayoutContext().widget
  const { activeParticipants } = useParticipantsList()

  const dispatch = useAppDispatch()
  const currentTab = useAppSelector(selectPiPCurrentTab)
  const unreadMessageCount = useAppSelector(selectUnreadMessages)

  const handleTabClick = useCallback(
    (value: TPiPTab) => {
      dispatch(setCurrentTab(value))

      if (value === 'participants') {
        changeLayoutContext({ msg: 'show_participants' })
      } else {
        changeLayoutContext({ msg: 'hide_participants' })
      }

      if (value === 'chat') {
        dispatch(setIsOpenChat(true))
      } else {
        dispatch(setIsOpenChat(false))
      }
    },
    [dispatch, changeLayoutContext],
  )

  const getBadge = useCallback(
    (tab: TPiPTab) => {
      let badge = null

      switch (tab) {
        case 'chat':
          badge = unreadMessageCount < 10 ? unreadMessageCount.toFixed(0) : '9+'
          break
        case 'participants':
          badge = activeParticipants.length + 1
          break

        default:
          break
      }

      return badge
    },
    [unreadMessageCount, activeParticipants.length],
  )
  const isAdmin = useAppSelector(selectIsAdmin)

  useEffect(() => {
    if (!isAdmin) {
      setDisplayedTabs((prev) => [...prev.filter((tab) => tab.value !== 'participants')])
    }
  }, [isAdmin])

  return (
    <nav className="pip-tabs-panel">
      <ul>
        {displayedTabs.map((tab) => (
          <TabItem
            key={tab.value}
            currentTab={currentTab}
            selectCurrentTab={handleTabClick}
            Badge={getBadge(tab.value)}
            {...tab}
          />
        ))}
      </ul>
    </nav>
  )
}
